module.exports = __webpack_public_path__ + "media/icons/map-research-766a3887.svg";